import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Calculator,
  Users,
  FileText,
  MessageCircle,
  ChevronDown,
  Check,
} from "lucide-react";
import { Reveal } from "../components/site/Layout";
import { services } from "../data/mock";

const iconMap = {
  Calculator,
  Users,
  FileText,
  MessageCircle,
};

const ServiceCard = ({ service, index }) => {
  const [open, setOpen] = useState(false);
  const Icon = iconMap[service.icon];
  return (
    <Reveal delay={(index % 2) * 120}>
      <div className="service-card" data-testid={`service-card-${service.slug}`}>
        <div className="service-card-icon">
          <Icon size={27} />
        </div>
        <h3 className="service-card-title">{service.title}</h3>
        <p className="service-card-text">{service.short}</p>
        <button
          type="button"
          className="service-card-link"
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
        >
          {open ? "Ascunde detaliile" : "Află mai multe"}
          <ChevronDown
            size={15}
            style={{
              transform: open ? "rotate(180deg)" : "none",
              transition: "transform 0.3s ease",
            }}
          />
        </button>
        {open && (
          <div style={{ marginTop: 18, borderTop: "1px solid var(--ce-border)", paddingTop: 18 }}>
            <p className="service-card-text" style={{ marginBottom: 14 }}>
              {service.description}
            </p>
            <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
              {service.bullets.map((b) => (
                <li
                  key={b}
                  style={{
                    display: "flex",
                    gap: 10,
                    alignItems: "flex-start",
                    fontSize: "0.9rem",
                    color: "var(--ce-text)",
                    marginBottom: 8,
                    lineHeight: 1.6,
                  }}
                >
                  <Check size={16} style={{ color: "var(--ce-teal)", flexShrink: 0, marginTop: 3 }} />
                  {b}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </Reveal>
  );
};

const Services = () => {
  return (
    <>
      <section className="page-hero">
        <div className="site-container">
          <h1>Serviciile noastre</h1>
          <p>
            Detaliile fiecărui serviciu și modul în care se desfășoară
            colaborarea.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="site-container">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
              gap: 32,
            }}
          >
            {services.map((s, i) => (
              <ServiceCard key={s.id} service={s} index={i} />
            ))}
          </div>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="site-container">
          <Reveal>
            <div className="cta-band">
              <h2>Nu ești sigur ce configurație ți se potrivește?</h2>
              <p>
                Într-o discuție scurtă analizăm situația și recomandăm
                serviciile relevante. Fără costuri și fără angajament.
              </p>
              <Link to="/contact" className="btn-accent">
                Contactează-ne
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
};

export default Services;
